import { render, staticRenderFns } from "./Lote.vue?vue&type=template&id=6b003ed4&scoped=true"
import script from "./Lote.vue?vue&type=script&lang=js"
export * from "./Lote.vue?vue&type=script&lang=js"
import style0 from "./Lote.vue?vue&type=style&index=0&id=6b003ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b003ed4",
  null
  
)

export default component.exports